function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.572 20.655a8.757 8.757 0 00.276-2.179l2.646-.751-1.528-5.402-2.813.835a8.891 8.891 0 00-2.572-2.421l.627-2.505-5.452-1.378-.627 2.505a9.025 9.025 0 00-3.406.91L5.627 8.2 1.72 12.23l1.97 1.962a8.867 8.867 0 00-1.043 4.175L0 19.144l1.528 5.402 2.814-.835a9.351 9.351 0 002.571 2.422l-.626 2.504 5.377 1.42.626-2.505a9.185 9.185 0 003.398-.902l2.104 2.046 3.907-4.025-1.97-1.92a9.135 9.135 0 00.835-2.079l.008-.017zm-9.827 1.67a4.007 4.007 0 111.963-7.77 4.007 4.007 0 01-1.963 7.77z",
  fill: "#7F63FF"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M27.97 5.068a4.179 4.179 0 00-.443-1.052l1.503-1.394L27.36.885l-1.503 1.411c-.62-.36-1.32-.56-2.037-.584L23.427 0l-2.329.568.418 1.72a4.358 4.358 0 00-1.553 1.47l-1.946-.569-.676 2.313 1.937.568a4.316 4.316 0 00.518 2.129l-1.453 1.377 1.67 1.737 1.47-1.403c.627.358 1.331.56 2.053.593l.417 1.72 2.322-.534-.418-1.729a4.416 4.416 0 001.536-1.452l1.962.576.677-2.313-1.937-.568a4.177 4.177 0 00-.125-1.135zm-3.883 2.688a1.67 1.67 0 111.102-.76 1.67 1.67 0 01-1.06.76h-.042z",
  fill: "#7F63FF"
});

function SvgUnfreezeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 31 31",
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "15c7f22b4c168bc39ad42df960962811.svg";
export { SvgUnfreezeIcon as ReactComponent };